module.exports = __webpack_public_path__ + "img/company23.3b4200eb.png";